// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fontKnu_6e4f6d', '__fontKnu_Fallback_6e4f6d'"},"className":"__className_6e4f6d"};